import { Container, BarContainer, Bar } from './ViralBarStyles';

interface ViralBarProps {
  color?: string;
  score?: number;
  topic?: string;
}

const ViralBar = ({ color = '#fff', score = 0, topic }: ViralBarProps) => {
  let score_ = Math.max(score, 2);
  if (score_ > 100) score_ = 100;
  if (score_ < 0) score_ = 0;

  return (
    <Container>
      <BarContainer>
        <Bar color={color} score={score_} />
      </BarContainer>
      <div className="text-text-300 text-sm">{topic}</div>
    </Container>
  );
};

export default ViralBar;
